import { EnvironmentConfigurations } from '@livefree/runtime';

export const LoginConfig = EnvironmentConfigurations.hydrate({
  development: {
    host: 'https://localhost:44354',
    api: {
      host: 'https://localhost:44354',
      apiKey: 'LoginAPI',
    },
    auth: {
      host: 'https://localhost:44354',
      clientId: '3ca9028648b149a89b26ad65ca335412',
      scopes: 'openid profile email phone IdentityServerApi',
      applicationKey: '2a4821db64eb4c718a823f8031838c1d',
    },
  },
  staging: {
    host: 'https://lf-login-staging.azurewebsites.net',
    api: {
      host: 'https://lf-login-staging.azurewebsites.net',
      apiKey: 'LoginAPI',
    },
    auth: {
      host: 'https://lf-login-staging.azurewebsites.net',
      clientId: '3ca9028648b149a89b26ad65ca335412',
      scopes: 'openid profile email phone IdentityServerApi',
      applicationKey: '2a4821db64eb4c718a823f8031838c1d',
    },
  },
  production: {
    host: 'https://login.lifebeacon.com',
    api: {
      host: 'https://login.lifebeacon.com',
      apiKey: 'LoginAPI',
    },
    auth: {
      host: 'https://login.lifebeacon.com',
      clientId: '3ca9028648b149a89b26ad65ca335412',
      scopes: 'openid profile email phone IdentityServerApi',
      applicationKey: '899505fcae7e40809189f32803bd7a86',
    },
  },
});
